import React from "react";
import styled from "styled-components";

export interface Row {
  _key: string;
  cells: string[];
}

export interface TableProps {
  rows: Row[];
  description: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  table {
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }
`;

const Description = styled.div`
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-normal);
  line-height: 22.4px;
  margin-bottom: 16px;
`;

const Table = ({ rows, description }: TableProps) => {
  const headers = rows[0].cells;
  const bodyItems = rows.slice(1);

  return (
    <Container>
      <table>
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {bodyItems.map((item) => (
            <tr key={`${item._key}`}>
              {item.cells.map((cell, i) => (
                <td key={`${cell}__${i}`}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {description && <Description>{description}</Description>}
    </Container>
  );
};

export default Table;
